import { IconActionArrowUpRight16 } from '@cian/ui-kit-design-tokens/icons';

import styles from './PostfixPopupLink.css';
import { UIText2 } from '@cian/ui-kit';

interface IPostfixPopupLinkProps {
  href: string;
  text: string;
}

export const PostfixPopupLink: React.FC<IPostfixPopupLinkProps> = ({ text, href }) => {
  return (
    <a href={href} className={styles['container']}>
      <span className={styles['text']}>
        <UIText2 color="primary_100">{text}</UIText2>
      </span>
      <IconActionArrowUpRight16 color="icon-main-default" />
    </a>
  );
};
